import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';
import { editCustNum } from '@/pages/settings/redux/slice';
//  createCategory
import { Col, Form, Input, Row, Skeleton, message, Select, Switch } from 'antd';
import styles from './index.module.less';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import {
  CaretDownFilled
  // CaretDownOutlined,
  // DeleteOutlined,
  // HolderOutlined,
  // PlusCircleFilled,
  // RightOutlined
} from '@ant-design/icons';

const EditModal = ({
  byIdLoading,
  setId,
  id,
  getCUSTNum_id,
  onCancel,
  isEditModalVisible,
  setIsEditModalOpen,
  handlegetCostCenterNum
}) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const {
    get_plants,
    get_functions
    // get_category,
    // get_subcategorylist,
    // get_activity
  } = useSelector((state) => state.dashboard);
  const [isActive, setIsActive] = useState(getCUSTNum_id?.[0]?.is_active);
  // const [checked, setChecked] = useState(false);
  console.log('getCUSTNum_id', getCUSTNum_id);
  // const handleChange = (checked) => {
  //   setChecked(checked);
  // };
  const [form] = Form.useForm();
  useEffect(() => {
    setId(getCUSTNum_id?.[0]?.id);
    setIsActive(getCUSTNum_id?.[0]?.is_active);
    /*  setAppId(flowData.app_id); */
    form.setFieldsValue({
      // is_active: plant_id?.[0]?.is_active,
      action: getCUSTNum_id?.[0]?.is_active,
      plant_id: getCUSTNum_id?.[0]?.plant_id,
      name: getCUSTNum_id?.[0]?.name,
      department_id: getCUSTNum_id?.[0]?.department_id
      // amount: getCUSTNum_id?.[0]?.amount
    });
  }, [getCUSTNum_id, form]);

  const onFinish = (values) => {
    values['id'] = id;
    values['action'] = isActive ? 'activate' : 'deactivate';
    dispatch(editCustNum(values)).then((response) => {
      if (response.payload.success) {
        message.success(response.payload.message);
        setIsEditModalOpen(false);
        handlegetCostCenterNum();
      } else {
        message.error(response.payload.message);
      }
    });
  };
  const handleSwitchChange = (checked) => {
    console.log('checked', checked);
    setIsActive(checked);
  };
  return (
    <CustomModal
      footer={
        <Form
          onFinish={onFinish}
          form={form}
          layout="vertical"
          className="ant-form ant-form-vertical"
        >
          <Row>
            <Col className="text-left" span={12}>
              <CustomButton onClick={onCancel}>Cancel</CustomButton>{' '}
            </Col>
            <Col className="text-right" span={12}>
              <CustomButton type="primary" htmlType="submit">
                Edit
              </CustomButton>
            </Col>
          </Row>
        </Form>
      }
      onCancel={onCancel}
      visible={isEditModalVisible}
      title="Edit Cost Center Details"
    >
      {byIdLoading ? (
        <Skeleton />
      ) : (
        <Form
          onFinish={onFinish}
          form={form}
          layout="vertical"
          className="ant-form ant-form-vertical"
        >
          <Row gutter={24}>
            {/* <Col span={12}> */}
            {/* <FormItem
                label={'Cost Center Num'}
                name="name"
                // className={`${styles.astrick}`}
                rules={[
                  {
                    required: true,
                    message: 'Please enter cost center no'
                  }
                ]}
              >
                <Input placeholder="Enter cost center no" disabled />
              </FormItem>
            </Col> */}
            <Col span={12}>
              <FormItem
                name="plant_id"
                label="Plant"
                rules={[
                  {
                    required: true,
                    message: 'Please plant'
                  }
                ]}
              >
                <Select
                  filterOption={(inputValue, option) =>
                    option.props.children
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  // onSearch={handleSubCategorySearch}
                  showSearch
                  suffixIcon={<CaretDownFilled />}
                  placeholder="Select Plant"
                >
                  {get_plants
                    // ?.filter((item) => item.new_sub_cat_doa)
                    ?.map((item, index) => (
                      <Option key={index} value={item.id}>
                        {item.is_active === false
                          ? `${item.name} (Deactivated)`
                          : item.name}
                      </Option>
                    ))}
                </Select>
              </FormItem>
            </Col>

            {/* Department */}
            <Col span={12}>
              <FormItem
                name="department_id"
                label="Department"
                rules={[
                  {
                    required: true,
                    message: 'Please department'
                  }
                ]}
              >
                <Select
                  filterOption={(inputValue, option) =>
                    option.props.children
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  // onSearch={handleSubCategorySearch}
                  showSearch
                  suffixIcon={<CaretDownFilled />}
                  placeholder="Select Department"
                >
                  {get_functions
                    // ?.filter((item) => item.new_sub_cat_doa)
                    ?.map((item, index) => (
                      <Option key={index} value={item.id}>
                        {item.is_active === false
                          ? `${item.name} (Deactivated)`
                          : item.function_name}
                      </Option>
                    ))}
                </Select>
              </FormItem>
            </Col>
            {/* Department End */}

            <Col span={24}>
              <FormItem
                label={'Cost Center'}
                name="name"
                // className={`${styles.astrick}`}
                rules={[
                  {
                    required: true,
                    message: 'Please enter cost center'
                  }
                ]}
              >
                <Input placeholder="Enter cost center" />
              </FormItem>
            </Col>

            {/* <Col span={12}>
              <FormItem
                label={'Cost Center Amount'}
                name="amount"
                // className={`${styles.astrick}`}
                rules={[
                  {
                    required: true,
                    message: 'Please enter name'
                  },
                  {
                    pattern: /^\d*\.?\d*$/,
                    message: 'Please enter a valid numeric value'
                  }
                ]}
              >
                <Input placeholder="Enter Plant Name" />
              </FormItem>
            </Col> */}
            <Col span={24}>
              <FormItem
                label={'Status'}
                name="action"
                // className={`${styles.astrick}`}
                rules={[
                  {
                    required: true,
                    message: 'Please enter'
                  }
                ]}
              >
                <div
                  className={
                    isActive
                      ? `${styles.switcher_container}`
                      : `${styles.switcher_container1}`
                  }
                >
                  <Switch checked={isActive} onChange={handleSwitchChange} />
                </div>
              </FormItem>
            </Col>
          </Row>
        </Form>
      )}
    </CustomModal>
  );
};

export default EditModal;
